import React from 'react';

const CaseStages = ({
    stages,
    tasks,
    updateStageStatus,
    completeAllTasksForStage,
    stageTaskDrafts,
    setStageDraft,
    addStageTask
}) => {
    return (
        <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
            <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex justify-between items-center">
                <h4 className="text-lg font-bold text-blue-400 uppercase tracking-wider flex items-center gap-2">
                    🎯 STAGES
                </h4>
            </div>
            <ul className="divide-y divide-gray-700">
                {stages.map(s => {
                    const openTasks = (tasks || []).filter(t => t.stage_id === s.id && t.status !== 'done').length;
                    return (
                        <li key={s.id} className="p-4 hover:bg-gray-700/30 transition-colors">
                            <div className="flex items-center justify-between mb-3">
                                <div className="flex-1">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-3 h-3 rounded-full ${s.status === 'done' ? 'bg-green-500' : s.status === 'active' ? 'bg-blue-500 animate-pulse' : 'bg-gray-600'}`}></div>
                                        <div className="font-bold text-white text-lg tracking-wide">{s.title}</div>
                                    </div>
                                    <div className="text-xs text-gray-500 mt-1 flex items-center gap-3 font-mono uppercase ml-6">
                                        <span className={`px-2 py-0.5 rounded border ${s.status === 'done' ? 'bg-green-900/30 text-green-400 border-green-800' : s.status === 'active' ? 'bg-blue-900/30 text-blue-400 border-blue-800' : 'bg-gray-700 text-gray-400 border-gray-600'}`}>
                                            {s.status}
                                        </span>
                                        <span>OPEN TASKS: <span className="text-white font-bold">{openTasks}</span></span>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button onClick={() => updateStageStatus(s, 'pending')} className="px-3 py-1.5 rounded text-xs font-bold bg-gray-700 text-gray-300 hover:bg-gray-600 border border-gray-600 uppercase tracking-wider">Pending</button>
                                    <button onClick={() => updateStageStatus(s, 'active')} className="px-3 py-1.5 rounded text-xs font-bold bg-blue-600 text-white hover:bg-blue-700 border border-blue-500 uppercase tracking-wider">Activate</button>
                                    <button onClick={() => updateStageStatus(s, 'done')} className="px-3 py-1.5 rounded text-xs font-bold bg-green-600 text-white hover:bg-green-700 border border-green-500 uppercase tracking-wider">Done</button>
                                    {s.status !== 'done' && (
                                        <button onClick={() => completeAllTasksForStage(s)} className="px-3 py-1.5 rounded text-xs font-bold bg-gray-700 text-white border border-gray-600 hover:bg-gray-600 uppercase tracking-wider ml-2">
                                            Complete All &raquo;
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="ml-6 pl-4 border-l-2 border-gray-700 space-y-2 font-mono text-xs text-gray-500">
                                {s.started_at && <div>STARTED: <span className="text-gray-300">{new Date(s.started_at).toLocaleString()}</span></div>}
                                {s.completed_at && <div>COMPLETED: <span className="text-gray-300">{new Date(s.completed_at).toLocaleString()}</span></div>}
                            </div>

                            {/* Inline add task for stage */}
                            {s.status !== 'done' && (
                                <div className="mt-4 ml-6 flex items-center gap-2 bg-gray-900/50 p-2 rounded border border-gray-700">
                                    <input
                                        className="flex-1 bg-transparent border-none text-white placeholder-gray-600 text-sm focus:ring-0 font-mono"
                                        placeholder="ADD TASK TO THIS STAGE..."
                                        value={(stageTaskDrafts[s.id]?.title) || ''}
                                        onChange={(e) => setStageDraft(s.id, { title: e.target.value })}
                                    />
                                    <input
                                        type="date"
                                        className="w-32 bg-gray-800 border border-gray-600 rounded px-2 py-1 text-white text-xs focus:ring-1 focus:ring-blue-500 font-mono"
                                        value={(stageTaskDrafts[s.id]?.due_date) || ''}
                                        onChange={(e) => setStageDraft(s.id, { due_date: e.target.value })}
                                    />
                                    <button
                                        onClick={() => addStageTask(s.id)}
                                        className="px-3 py-1 rounded text-xs font-bold bg-blue-600 text-white hover:bg-blue-700 uppercase"
                                    >
                                        Add
                                    </button>
                                </div>
                            )}
                        </li>
                    );
                })}
                {stages.length === 0 && <li className="text-center py-12 text-gray-500 font-mono uppercase">No stages configured</li>}
            </ul>
        </div>
    );
};

export default CaseStages;
